module.exports = __webpack_public_path__ + "img/logo-cer-05.5edc8c52.png";